export const ENV_VARIABLES = {
  API_URL: 'VITE_API_URL',
  API_SERVER_URL: 'VITE_API_SERVER_URL',
  SOCKET_URL: 'VITE_SOCKET_URL',
  REDIS_URL: 'VITE_REDIS_URL',
  CDN_URL: 'VITE_CDN_URL',
  AUTH0_DOMAIN: 'VITE_AUTH0_DOMAIN',
  AUTH0_CLIENT_ID: 'VITE_AUTH0_CLIENT_ID',
  AUTH0_AUDIENCE: 'VITE_AUTH0_AUDIENCE',
  STRIPE_KEY: {
    TEST: 'VITE_STRIPE_KEY_TEST',
    PRODUCTION: 'VITE_STRIPE_KEY_PRODUCTION',
  },
};

export const DEFAULT_VALUES = {
  development: {
    apiUrl: 'http://localhost:5173',
    apiServerUrl: 'http://localhost:8080',
    socketUrl: 'ws://localhost:8080',
    stripeKey: 'test_key',
    redisUrl: 'redis://localhost:6379',
    cdnUrl: 'https://cdn.donvio.com',
    auth0: {
      domain: '',
      clientId: '',
      audience: 'https://donvio-dev.us.auth0.com/api/v2/',
    },
  },
  staging: {
    // No fallback defaults for staging - environment variables are REQUIRED
    apiUrl: '',
    apiServerUrl: '',
    socketUrl: '',
    stripeKey: '',
    redisUrl: '',
    cdnUrl: '',
    auth0: {
      domain: '',
      clientId: '',
      audience: '',
    },
  },
  production: {
    // No fallback defaults for production - environment variables are REQUIRED
    apiUrl: '',
    apiServerUrl: '',
    socketUrl: '',
    stripeKey: '',
    redisUrl: '',
    cdnUrl: '',
    auth0: {
      domain: '',
      clientId: '',
      audience: '',
    },
  },
};

/**
 * Authentication and Route Protection Timeouts
 * Centralized timeout constants to ensure consistent UX across the app
 */
export const AUTH_TIMEOUTS = {
  /** Primary auth check timeout - used in App.tsx for initial auth */
  APP_AUTH_LOADING: 5000, // 5 seconds

  /** Route-level auth check timeout - used in ProtectedRoute */
  ROUTE_AUTH_CHECK: 7000, // 7 seconds

  /** Router config fallback timeout - final safety net */
  ROUTER_FALLBACK: 10000, // 10 seconds

  /** React Query stale time for subscriptions */
  SUBSCRIPTION_STALE_TIME: 10 * 60 * 1000, // 10 minutes

  /** React Query cache time for subscriptions */
  SUBSCRIPTION_CACHE_TIME: 15 * 60 * 1000, // 15 minutes
} as const;
